import React from 'react';
import PropTypes from 'prop-types';
import SearchForm from './SearchForm'
import FieldGroup from './FieldGroup'
import FormControl from './Controls/FormControl';
import Icon from '../Icon';
import classNames from 'classnames';

const SearchComponent = props => {
  const { disabled, searchAction, valueChangeDelay, wrapperClass, value, ...controlProps } = props;

  const wrapperClasses = classNames(
    'search-wrapper',
    wrapperClass,
    { disabled }
  );

  return (
    <SearchForm
      className={wrapperClasses}
      searchAction={searchAction}
      valueChangeDelay={valueChangeDelay}
      defaultValues={{ searchValue: value }}
    >
      <div className="search-icon">
        <Icon iconType="search" />
      </div>
      <FieldGroup className="search-input">
        <FormControl disableSubmit={true} disabled={disabled} {...controlProps} />
      </FieldGroup>
    </SearchForm>
  );
}

SearchComponent.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  searchAction: PropTypes.func.isRequired,
  value: PropTypes.object,
  valueChangeDelay: PropTypes.number,
  wrapperClass: PropTypes.string
};

SearchComponent.defaultProps = {
  name: 'searchValue'
};

export default SearchComponent;
